export type WordLength = 4 | 5 | 6 | 7 | 8;

export type GameLang = 'pt' | 'en';

export type LetterFeedback = 'correct' | 'present' | 'absent';

export type GameMode = 'random' | 'custom' | 'challenge';

export type GameStatus = 'playing' | 'won' | 'lost';

export interface GuessRow {
  word: string;
  feedback: LetterFeedback[];
}

export interface ChallengerResult {
  guesses: GuessRow[];
  status: 'won' | 'lost';
}

export interface WordleState {
  id: string;
  target: string;
  length: WordLength;
  lang: GameLang;
  maxAttempts: number;
  guesses: GuessRow[];
  status: GameStatus;
  mode: GameMode;
  challengerNick?: string;
  challengerResult?: ChallengerResult;
}

export const WORD_LENGTHS: readonly WordLength[] = [4, 5, 6, 7, 8];

export const GAME_LANGS: readonly GameLang[] = ['pt', 'en'];

export const DEFAULT_GAME_LANG: GameLang = 'pt';

export function isWordLength(value: number): value is WordLength {
  return WORD_LENGTHS.includes(value as WordLength);
}

export function isGameLang(value: unknown): value is GameLang {
  return value === 'pt' || value === 'en';
}

export function maxAttemptsForLength(length: WordLength): number {
  return length + 1;
}
